/* eslint-disable */
import reduceReducers from 'reduce-reducers';
import { Reducer } from 'redux';

import { DEFAULT_PER_PAGE_COUNT } from '@/services/constants';

import { apiCampaigns } from './apiCampaigns/reducer';
import { AbSplitDisplayMode, CampaignsActionTypes, CampaignsInterface } from './types';
import { simpleStatsAllData } from './simpleStats/reducer';

export const CampaignsInitialState: CampaignsInterface = {
    loading: false,
    byTarget: null,
    collection: [],
    checkedCampaigns: [],
    pagination: {
        activePage: 1,
        perPage: DEFAULT_PER_PAGE_COUNT,
    },
    pickedCampaign: { isChartDataLoading: false, campaign: null, simpleStats: null },
    abSplitHeaderControls: {
        displayMode: AbSplitDisplayMode.TestResult,
        currentTemplate: null,
    },
    currentPreview: {
        isTemplateDeleted: false,
        campaign: null,
        templates: null,
    },
    pickedContactEmail: null,
    locationCountryStats: { loading: false, totalCount: 0, dataSetByCountry: [] },
    deleteDialog: {
        isOpened: false,
        campaignNames: [],
        type: null,
    },
    copyCampaignsLoading: false,
    copiedCampaign: null,
    simpleStatsAllData: null,
    isCampaignCreatorOpen: false,
    contactsList: null,
    campaignsNames: null,
};

const campaign: Reducer<CampaignsInterface> = (
    state: CampaignsInterface = CampaignsInitialState,
    action
): CampaignsInterface => {
    switch (action.type) {
        case CampaignsActionTypes.LOAD_BY_TARGET_START:
        case CampaignsActionTypes.LOAD_BY_TARGET_SUCCESS:
        case CampaignsActionTypes.SET_CAMPAIGN_CREATOR_OPEN:
            return { ...state, ...action.payload };
        case CampaignsActionTypes.PICK_CAMPAIGNS:
            return { ...state, checkedCampaigns: action.payload.checkedCampaigns };
        case CampaignsActionTypes.CHANGE_AUTORESPONDER_STATUS_SUCCESS:
        case CampaignsActionTypes.CANCEL_CAMPAIGN_SUCCESS:
            return { ...state, collection: action.payload.collection };
        case CampaignsActionTypes.LOAD_ALL_SUCCESS:
            return {
                ...state,
                collection: action.payload.collection,
                statusCount: action.payload.statusCount,
                loading: false,
            };
        case CampaignsActionTypes.UPDATE_PAGINATION:
            return { ...state, pagination: action.payload.pagination };
        case CampaignsActionTypes.LOAD_ALL_ERROR:
        case CampaignsActionTypes.LOAD_PREVIEW_TEMPLATES_ERROR:
            return { ...state, loading: false };
        case CampaignsActionTypes.OPEN_MODAL_DELETE_CAMPAIGNS:
            return {
                ...state,
                deleteDialog: {
                    isOpened: true,
                    campaignNames: action.payload.campaignNames,
                    type: action.payload.type,
                },
            };
        case CampaignsActionTypes.CLOSE_MODAL_DELETE_CAMPAIGNS:
            return {
                ...state,
                deleteDialog: {
                    isOpened: false,
                    campaignNames: [],
                    type: null,
                },
            };
        case CampaignsActionTypes.DELETE_CAMPAIGNS_SUCCESS:
            return { ...state, loading: false, checkedCampaigns: [] };
        case CampaignsActionTypes.UNPICK_CAMPAIGNS:
            return { ...state, checkedCampaigns: [] };
        case CampaignsActionTypes.LOAD_PREVIEW_TEMPLATES_SUCCESS:
            return { ...state, loading: false, currentPreview: { ...state.currentPreview, ...action.payload } };
        case CampaignsActionTypes.PREVIEW_CAMPAIGN:
        case CampaignsActionTypes.PREVIEW_CAMPAIGN_CLEAR:
            return { ...state, currentPreview: { ...state.currentPreview, ...action.payload } };
        case CampaignsActionTypes.POLLING_CAMPAIGN_SIMPLE_STATS_SUCCESS:
        case CampaignsActionTypes.GET_CAMPAIGN_SIMPLE_STATS_SUCCESS:
            return {
                ...state,
                pickedCampaign: {
                    ...state.pickedCampaign,
                    simpleStats: {
                        CampaignTemplatesSummary: action.payload.CampaignTemplatesSummary,
                    },
                    campaign: {
                        ...state.pickedCampaign.campaign,
                        Stats: { ...action.payload.Stats },
                        Status: action.payload.Status,
                    },
                },
                loading: false,
            };
        case CampaignsActionTypes.GET_CAMPAIGN_SIMPLE_STATS:
        case CampaignsActionTypes.GET_IN_PROGRESS_CAMPAIGN_BY_CHANNEL_NAME:
        case CampaignsActionTypes.LOAD_ALL:
        case CampaignsActionTypes.DELETE_CAMPAIGNS_START:
            return { ...state, loading: true };
        case CampaignsActionTypes.GET_IN_PROGRESS_CAMPAIGN_BY_CHANNEL_NAME_SUCCESS:
            return { ...state, inProgressCampaign: action.payload.inProgressCampaign, loading: false };
        case CampaignsActionTypes.CANCEL_POLLING_IN_PROGRESS_CAMPAIGN_BY_CHANNEL_NAME:
            return { ...state, inProgressCampaign: null, loading: false };
        case CampaignsActionTypes.GET_CAMPAIGN_BY_NAME_SUCCESS:
            return CampaignsByNameSuccess(state, action);
        case CampaignsActionTypes.CLEAR_PICKED_CAMAPAIGN:
            return { ...state, pickedCampaign: { ...state.pickedCampaign, campaign: null, simpleStats: null } };
        case CampaignsActionTypes.SET_ABSPLIT_CAMPAIGN_TEMPLATES_LABELS:
            return {
                ...state,
                pickedCampaign: { ...state.pickedCampaign, templateLabels: action.payload },
            };
        case CampaignsActionTypes.GET_CAMPAIGN_CLICKS_AND_OPENS_CHART_DATA:
            return {
                ...state,
                pickedCampaign: { ...state.pickedCampaign, isChartDataLoading: true },
            };
        case CampaignsActionTypes.GET_CAMPAIGN_CLICKS_AND_OPENS_CHART_DATA_SUCCESS:
            return {
                ...state,
                pickedCampaign: {
                    ...state.pickedCampaign,
                    clicksAndOpensChartData: action.payload.clicksAndOpensChartData,
                    isChartDataLoading: false,
                },
            };
        case CampaignsActionTypes.SET_ABSPLIT_DISPLAY_MODE:
            return {
                ...state,
                abSplitHeaderControls: {
                    ...state.abSplitHeaderControls,
                    displayMode: action.payload.displayMode,
                },
            };
        case CampaignsActionTypes.SET_ABSPLIT_CURRENT_TEMPLATE:
            return {
                ...state,
                abSplitHeaderControls: {
                    ...state.abSplitHeaderControls,
                    currentTemplate: action.payload.currentTemplate,
                },
            };
        case CampaignsActionTypes.SET_PICKED_CONTACT_EMAIL:
            return { ...state, pickedContactEmail: action.payload.pickedContactEmail };
        case CampaignsActionTypes.GET_LOCATION_STATS_BY_COUNTRYISO_START:
            return { ...state, locationCountryStats: { ...state.locationCountryStats, loading: true } };
        case CampaignsActionTypes.GET_LOCATION_STATS_BY_COUNTRYISO_SUCCESS:
            return {
                ...state,
                locationCountryStats: {
                    dataSetByCountry: action.payload.params.dataSetByCountry,
                    loading: action.payload.loading,
                    totalCount: action.payload.params.totalCount,
                },
            };
        case CampaignsActionTypes.COPY_CAMPAIGNS_BY_NAME_START:
            return { ...state, copyCampaignsLoading: true };
        case CampaignsActionTypes.COPY_CAMPAIGNS_BY_NAME_SUCCESS:
            return { ...state, copyCampaignsLoading: false, copiedCampaign: action.payload.copiedCampaign };
        case CampaignsActionTypes.COPY_CAMPAIGNS_BY_NAME_ERROR:
            return { ...state, copyCampaignsLoading: false };
        case CampaignsActionTypes.TEMPLATE_DELETED_STATUS:
            return { ...state, currentPreview: { isTemplateDeleted: true } };
        case CampaignsActionTypes.CAMPAIGNS_NAMES:
            return GetCampaignsNames(state);
        case CampaignsActionTypes.UPDATE_CAMPAIGNS_NAMES:
            return CampaignsNamesUpdate(state, action);
        case CampaignsActionTypes.CAMPAIGNS_NAMES_ERROR:
            return CampaignsNamesError(state);
        default:
            return state;
    }
};

const GetCampaignsNames = (state: CampaignsInterface = CampaignsInitialState): CampaignsInterface => ({
    ...state,
    campaignsNamesLoading: true,
});
const CampaignsNamesUpdate = (state: CampaignsInterface = CampaignsInitialState, action): CampaignsInterface => ({
    ...state,
    campaignsNames: action.payload.campaignsNames,
    campaignsNamesLoading: false,
});

const CampaignsNamesError = (state: CampaignsInterface = CampaignsInitialState): CampaignsInterface => ({
    ...state,
    campaignsNamesLoading: false,
});

const CampaignsByNameSuccess = (state: CampaignsInterface = CampaignsInitialState, action): CampaignsInterface => ({
    ...state,
    pickedCampaign: {
        ...state.pickedCampaign,
        campaign: { ...action.payload.pickedCampaign },
        simpleStats: { ...state.pickedCampaign.simpleStats },
    },
});

const reducers = reduceReducers(campaign, simpleStatsAllData, apiCampaigns as any);

export { reducers as campaigns };

export default reducers;
